import React from 'react'
import DoubleDonation from 'components/DoubleDonation'
import parser from 'html-react-parser'

export default function DonationForm({data}) {
    const {donationFormText} = data
    return (
        <div className='donate-lets-search-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <DoubleDonation />
                        <p>{donationFormText && parser(donationFormText)}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
